<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS()">
    <q-input :label="getTitle()" :clearable="formProperty.readonly ? false : true" @update:model-value="onChange" debounce="500" :prefix="formProperty.titlePrefix" :suffix="formProperty.titleSuffix"
             :maxlength="formProperty.lengthMax" :readonly="formProperty.readonly || readOnly" bottom-slots :error="propertyHasError"
             :error-message="getErrorLabel()" v-model="displayValue" :autofocus="formProperty.autofocus" type="text" inputmode="number"
             :filled="true" :dense="volatile || compressed" :hint="getHint()" hide-hint :class="'fld' + formProperty.nativename + ' ' + formProperty.cssClass"
             :placeholder="formProperty.infoTextHint" :id="formProperty.nativename" :ref="formProperty.nativename" @keydown="keyhandler">

      <template #append v-if="formProperty.ocrType>0">
        <q-icon name="ion-qr-scanner" class="cursor-pointer" @click="ocrInitLoading=true;showOCRDlg?showOCRDlg=false:showOCRDlg=true"/>
      </template>
    </q-input>

    <!--
        <div v-else class="roRow">
          <span class="roLabel" v-html="getTitle() + ':'"></span>
          <span class="roValue" v-html="value"></span>
        </div>
    -->
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'

import {maxValue, minLength, minValue, requiredIf} from '@vuelidate/validators'
import {fldComponentsMixin} from './mixins/fldComponent'
import {StaticData} from 'src/classes/StaticData'
import {setCssVar} from 'quasar'
import {useAuthStore} from 'src/stores/AuthStore.js'

export default {
  mixins: [fldComponentsMixin],
  props: [
    'formProperty',
    'queryID',
    'volatile',
    'compressed',
    'readOnly'
  ],
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      StaticData,
      value: this.getValue(), // formatted value (with , as comma),
      NumericSettings:
        {
          negativeSignCharacter: "-",
          decimalCharacter: ",",
          digitGroupSeparator: "",
          unformatOnHover: false,
          selectOnFocus: false
        },
    }
  },
  computed: {
    displayValue: {
      get() {
        // Wenn value einen Punkt enthält, wandle ihn in ein Komma um
        return this.value ? String(this.value).replace('.', ',') : this.value;
      },
      set(newValue) {
        // Der Wert wird über onChange gesetzt
        this.onChange(newValue);
      }
    },
    propertyHasError() {
      return (this.v$.value.$error && !this.v$.$errors.map(err => err.$validator).includes('requiredIf')) || this.formProperty.invalid
    }
  },
  validations() {
    return this.getValidations()
  },
  watch: {
    value: function () {
      this.formProperty.value = this.value ? (("" + this.value).replace(',', '.')) : this.value
      //this.value = ("" + this.value).replace(",", ".")
    },
    formProperty: {
      handler: function (newVal) {
        this.value = newVal.value
      },
      deep: false
    }
  },
  methods: {
    getInputMode() {
      // Nutzt Quasar's Platform Detection
      return this.$q.platform.is.ios ? null : 'numeric';
    },
    keyhandler: function (event) {
      switch (event.key) {
        case "ArrowDown":
        case "ArrowUp":
          event.preventDefault();
      }
    },
    getValidations() {
      let result = {value: {commaPreValidate, commaPostValidate, isFloat}}
      // result.value['minValue'] = minValue(this.formProperty.valueMin)
      result.value['minValue'] = this.customMinValue(this.formProperty.valueMin)

      // if (this.formProperty.valueMax > 0) result.value['maxValue'] = maxValue(this.formProperty.valueMax)
      if (this.formProperty.valueMax > 0) result.value['maxValue'] = this.customMaxValue(this.formProperty.valueMax)
      else result.value['maxValue'] = maxValue(999999999)

      result.value['minLength'] = minLength(this.formProperty.lengthMin)
      result.value['isValidGen'] = () => {  // generell invalid flag (triggered from extern)
        if (!this.formProperty.invalid) return true;
        return !this.formProperty.invalid
      }
      result.value['requiredIf'] = requiredIf(() => {
        if (this.formProperty.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
          return (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) && this.formProperty.showThroughDependency == true
        } else {
          return this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY
        }
      })
      return result
    },
    customMinValue(min) {
      return (value) => {
        if (!value && value !== 0) return true;
        const numValue = parseFloat(String(value).replace(',', '.'));
        return !isNaN(numValue) && numValue >= min;
      }
    },
    customMaxValue(max) {
      return (value) => {
        if (!value && value !== 0) return true;
        const numValue = parseFloat(String(value).replace(',', '.'));
        return !isNaN(numValue) && numValue <= max;
      }
    },
    onChange(value) {
      if (value) value = value.replace(',', '.');

      this.formProperty.invalid = false
      this.v$.$touch()
      this.value = value
      this.formProperty.value = value
      this.setErrorBrandColor()

      /*
            this.$emit('onChange', {
              classID: this.formProperty.classID,
              nativename: this.formProperty.nativename, deleteDependentFields: false, value: this.value
            })  // send onChange event to parent (formular or parameter)
      */

      // logger.info("onChange of ", this.formProperty.title, " = ", this.value)
      this.$emit('onChange', {
        classID: this.formProperty.classID,
        parentClassID: this.formProperty.parentFormPointer?.classID,
        nativename: this.formProperty.nativename,
        deleteDependentFields: true,
        value: this.value
      })

      if (this.$route.name === StaticData.ROUTE_NAMES.FORMULAR) {
        this.eventBus.formularEdited()
      }

      if (this.volatile && (this.formProperty.instantRefresh || this.formProperty.instantRefresh === undefined)) {
        this.$emit('onEnter')  // submit volatile parameters for immediate refresh
      }
    },
    getValue() {
      const authStore = useAuthStore()
      if (this.formProperty.value && ("" + this.formProperty.value).includes(',')) this.formProperty.value = ("" + this.formProperty.value).replace(',', '.')
      if (this.formProperty.value && parseFloat(this.formProperty.value)) this.formProperty.value = parseFloat(this.formProperty.value)
      if (this.formProperty.defaultValue && ("" + this.formProperty.defaultValue).includes(',')) this.formProperty.defaultValue = ("" + this.formProperty.defaultValue).replace(',', '.')
      if (this.formProperty.defaultValue && parseFloat(this.formProperty.defaultValue)) this.formProperty.defaultValue = parseFloat(this.formProperty.defaultValue)
      let result = this.formProperty.value
      let propertyName = this.formProperty.name ? this.formProperty.name : this.formProperty.nativename
      let storedValue = localStorage.getItem(this.queryID + "__" + propertyName)
      let deepLinkParamValue = authStore.queryParamListFromDeepLink[this.formProperty.nativename]

      if (deepLinkParamValue) {
        // parameter value, given as request parameter (e.g.: qp.name), set in store in router beforeEach
        result = deepLinkParamValue
        this.formProperty.value = deepLinkParamValue
        //delete authStore.queryParamListFromDeepLink[this.formProperty.nativename] // delete after one use from store
      } else if (storedValue != null && !this.formProperty.systemParameter) {
        result = storedValue
      } else if (!this.formProperty.value && this.formProperty.defaultValue) {
        result = this.formProperty.defaultValue
        this.formProperty.value = result
      }
      return result
    },
    // isInvalid() {
    //   return this.formProperty.invalid = this.v$.value.$error
    // },
    getErrorLabel() {
      let result = ""
      const errors = this.v$.$errors.map(err => err.$validator)
      // logger.info("🚀 ~ file: fldFloat.vue ~ line 119 ~ getErrorLabel ~ this.v$", this.v$)
      if (errors.includes("requiredIf")) {
        result = this.formProperty.infoRequired && this.formProperty.infoRequired != "" ? this.formProperty.infoRequired : "Feld muss befüllt werden."
      } else if (errors.includes("isFloat")) {
        result = "Ungültige Eingabe."
      } else if (errors.includes("commaPostValidate")) {
        result = "Ungültige Anzahl Nachkommastellen (max. " + this.formProperty.commaPost + ")"
      } else if (errors.includes("commaPreValidate")) {
        result = "Ungültige Anzahl Vorkommastellen (max. " + this.formProperty.commaPre + ")"
      } else if (errors.includes("minValue")) {
        result = "Minimaler Wert ist " + this.formProperty.valueMin
      } else if (errors.includes("maxValue")) {
        result = "Maximaler Wert ist " + this.formProperty.valueMax
      } else if (errors.includes("minLength")) {
        result = "Minimale Zeichenanzahl ist " + this.formProperty.lengthMin
      } else {
        result = this.formProperty.errorMsg
      }
      return result
    },
    setErrorBrandColor() {
      try {
        if (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) {
          setCssVar('negative', '#f57c00', document.getElementById('cont_' + this.formProperty.nativename))
        } else {
          setCssVar('negative', '#c10015', document.getElementById('cont_' + this.formProperty.nativename))
        }
      } catch (e) {
      }
    },

    onRefreshComp(data) {
      if (this.formProperty.parentFormPointer?.classID == data.parentClassID && (data.subtypeCount === undefined || data.subtypeCount === this.formProperty.subtypeCount) &&
        this.formProperty.nativename === data.nativename) {

        if (data.isEventFromParameter && !this.formProperty.isParameter) return

        // only refresh if we have data and it is not a staticTextField without SQL (which never can change)
        if (data.value !== undefined && data.value != null) {
          let myDepToken = this.formProperty.fieldDependencies ? this.formProperty.fieldDependencies.split(";") : ''
          // this component instance is a dependent field of changed field?
          if (myDepToken.includes(data.sourceChangedNativename)) {
            if (data.value && ("" + data.value).includes(',')) data.value = ("" + data.value).replace(',', '.')
            if (data.value && parseFloat(data.value)) data.value = parseFloat(data.value)
            //logger.info("!!! onRefreshComp of ", this.formProperty.title + " triggered.", this.formProperty.nativename, data.value, data.value.length)
            this.value = data.value
            this.formProperty.value = data.value

            if (data.errorMsg) this.formProperty.errorMsg = data.errorMsg
            else this.formProperty.errorMsg = ""
            if (data.errorFetchingData) this.formProperty.errorFetchingData = data.errorFetchingData
            else this.formProperty.errorFetchingData = ""

            if (data.errorMsg || data.errorFetchingData) this.formProperty.invalid = true
            else this.formProperty.invalid = false

            this.$forceUpdate()
            if (this.formProperty.instantRefresh &&
              //(this.formProperty.renderOnFrontend && (this.formProperty.showThroughDependency == true || this.formProperty.masterPropertyMode != StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE))) {
              (this.formProperty.showThroughDependency == true || this.formProperty.masterPropertyMode != StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
              //logger.info("cascade onChange ongoing from ", this.frmProperty.title)
              //logger.info("emit onchange for ", this.formProperty.nativename)
              this.$emit('onChange', {
                classID: this.formProperty.classID,
                parentClassID: this.formProperty.parentFormPointer?.classID,
                id: this.formProperty.ID,
                nativename: this.formProperty.nativename, deleteDependentFields: true, value: this.value
              })  // send onChange event to parent (formular or parameter)

            } else {
              this.showSpinner = false
            }
          }
        }
      }
    },

    onAutocompleteApplyButton(data) {
      if (this.formProperty.nativename == data.nativename && (data.subtypeCount == undefined || data.subtypeCount == this.formProperty.subtypeCount)) {
        this.value = data.value
        this.formProperty.value = data.value
        this.formProperty.errorMsg = ""
        this.formProperty.errorFetchingData = ""
        this.formProperty.invalid = false
        this.$forceUpdate()

        if (this.formProperty.instantRefresh && (this.formProperty.showThroughDependency == true || this.formProperty.masterPropertyMode != StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
          this.$emit('onChange', {
            classID: this.formProperty.classID,
            parentClassID: this.formProperty.parentFormPointer?.classID,
            id: this.formProperty.ID,
            nativename: this.formProperty.nativename,
            deleteDependentFields: true,
            value: this.value
          })  // send onChange event to parent (formular or parameter)
        } else {
          this.showSpinner = false
        }
      }
    },

    onSetPropertyValue(data) {
      if (this.formProperty.id === data.formProperty.id &&
        this.formProperty.parentFormPointer?.classID === data.formProperty.parentFormPointer?.classID &&
        (data.formProperty.subtypeCount === undefined || data.formProperty.subtypeCount === this.formProperty.subtypeCount)) {

        this.value = data.value
        this.formProperty.value = data.value
      }
    },
  },
  beforeUnmount() {
    this.eventBus.off('onRefreshComp', this.onRefreshComp)
    this.eventBus.off('onAutocompleteApplyButton', this.onAutocompleteApplyButton)
    this.eventBus.off('onSetPropertyValue', this.onSetPropertyValue)
  },

  mounted: function () {
    this.eventBus.on('onRefreshComp', this.onRefreshComp)
    this.eventBus.on('onAutocompleteApplyButton', this.onAutocompleteApplyButton)
    this.eventBus.on('onSetPropertyValue', this.onSetPropertyValue)
    this.formProperty.validate = () => {
      this.v$.$reset()
      this.v$.$touch()
      this.formProperty.invalid = this.v$.value.$error
      this.formProperty.errorMsg = this.getErrorLabel()
      this.setErrorBrandColor()

      if (this.formProperty.errorFetchingData != "") {
        this.formProperty.errorMsg = this.formProperty.errorFetchingData
        this.formProperty.invalid = true
      }
      //logger.info("validate - isInvalid", this.formProperty.title, this.formProperty.invalid )
    }

    this.formProperty.setValid = () => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // bug? - rerender field & errorstats
      this.formProperty.errorMsg = ""
      this.formProperty.invalid = false
      this.v$.$reset()
    }

    this.formProperty.setError = (errMsg) => {
      console.warn("setError of ", this.formProperty.title, " = ", errMsg)
      let tmp = this.value;
      this.value = "";
      this.value = tmp // rerender field & errorstats
      this.formProperty.errorMsg = errMsg
      this.formProperty.invalid = true
      this.v$.$touch()
    }

    // send onChange event to parent (formular or parameter)
    if (!this.formProperty.noInitOnChange && !this.formProperty.objInstanceID) {
      this.$emit('onChange', {
        classID: this.formProperty.classID,
        parentClassID: this.formProperty.parentFormPointer?.classID,
        nativename: this.formProperty.nativename,
        deleteDependentFields: false,
        value: this.value
      })
    }
  }
}

function isFloat(value) {
  if (!value || value == "") return true
  return isNaN(parseFloat(value)) ? false : true
}

function commaPostValidate(value) {
  let sval = ("" + value).replace(",", ".").replace("+", "").replace("-", "")
  let valOK = false

  if (sval.indexOf(".") > -1) {
    let postComma = sval.split(".")
    if (postComma[1].length <= this.formProperty.commaPost) valOK = true
  } else {
    valOK = true
  }
  //logger.info("this.formProperty.commaPost:", this.formProperty.commaPost, ", commaPostValidate: " + valOK)
  return valOK
}

function commaPreValidate(value) {
  let sval = ("" + value).replace(",", ".").replace("+", "").replace("-", "")
  let valOK = false

  if (!value || this.formProperty.commaPre == 0) return true

  if (sval.indexOf(".") < 0) {
    valOK = sval.length <= this.formProperty.commaPre

  } else {
    let preComma = sval.split(".")
    if (preComma[0].length <= this.formProperty.commaPre) valOK = true
  }
  //logger.info("this.formProperty.commaPre:", this.formProperty.commaPre, ", commaPreValidate: " + valOK)
  return valOK
}
</script>

<style lang="sass">
.q-field-label
  font-weight: bold

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button
  -webkit-appearance: none
  margin: 0

/* Firefox */
input[type=number]
  -moz-appearance: textfield

  //.q-field--dense .q-field__label
  //  top: 6px

  .q-field--dense
    font-size: 13px

  .q-field--dense .q-field__bottom
    padding-top: 2px
</style>
